import gql from 'graphql-tag'
import {CrudQuery} from '@hc/graphql'
import {Graphql} from '@hc/graphql'

export type HistoyFetchPaginationParams = {
  limit: number
  currentPage: number
}

export type HistoryItem = {
  id: number
  account_id: number
  account_type: string
  target_schema: string
  target_type: string
  target_id: number
  target_title: string
  transaction_id: string
  action: string
  changes: object
  data: object
};

export type HistoryFetchResult = {
  items?: HistoryItem[]
  count?: number
}

export class HistoryFetch {
  constructor(private params: HistoyFetchPaginationParams) {}

  async fetchHistoryCount(): Promise<HistoryFetchResult>{
    const query = new CrudQuery()

    query.count('system_activity')

    const [count] = await query.execute()

    return {count}
  }

  async fetchHistoryByDate(from: string, to: string): Promise<HistoryFetchResult> {
    const query = new CrudQuery()

    const conditions: Array<any> = [{created_at: {_gte: from, _lte: to}}]

    const where = {
      where: {_and: conditions}
    }

    query.count('system_activity', {...where})
    query.list('system_activity', {
      order: this.order,
      ...where
    })

    const [count, items] = await query.execute()

    return {count, items}
  }

  async fetchHistorybyObject(targetType: string, targetId: number): Promise<HistoryFetchResult> {
    const query = new CrudQuery()

    const where = {
      where: {
        target_type: {_eq: targetType},
        target_id: {_eq: targetId}
      }
    }
    query.count('system_activity', {...where})
    query.list('system_activity', {
      order: this.order,
      limit: this.params.limit,
      offset: this.offset,
      ...where
    })

    const [count, items] = await query.execute()

    return {count, items}
  }

  async fetchHistoryList(): Promise<HistoryFetchResult> {
    const query = new CrudQuery()

    query.count('system_activity')
    query.list('system_activity', {
      order: this.order,
      limit: this.params.limit,
      offset: this.offset,
    })

    const [count, items] = await query.execute()

    return {count, items}
  }

  async fetchHistoryDates(): Promise<any> {
    const {data: {dates: dates}} = await Graphql.apollo.query({
      query: gql(`
        query history_dates {
          dates: history_dates {
            dates
          }
        }
      `)
    })
    return {dates}
  }

  get offset() {
    return this.params.currentPage > 1
    ? (this.params.currentPage - 1) * this.params.limit
    : 0
  }

  get order() {
    return {created_at: 'desc'}
  }

}